import axios from 'axios';
import { getAuth } from 'firebase/auth';

const API_BASE_URL = '/.netlify/functions';

async function getIdToken() {
  const auth = getAuth();
  const user = auth.currentUser;
  if (!user) throw new Error('Użytkownik nie jest zalogowany');
  return user.getIdToken(/* forceRefresh= */ true);
}

export const fetchCasualResponse = async (message, chatHistory, isContinuation = false) => {
  const idToken = await getIdToken();
  try {
    const response = await axios.post(
      `${API_BASE_URL}/fetch-casual-response`,
      { message, chatHistory, isContinuation },
      { headers: { Authorization: `Bearer ${idToken}` } }
    );

    return response.data;
  } catch (error) {
    console.error("Error fetching casual response:", error.response?.data || error.message);
    throw new Error("Wystąpił błąd podczas generowania odpowiedzi. Spróbuj ponownie później.");
  }
};